import '@fancyapps/fancybox';
import modalsListeners from "./modals-listeners"
import modalGallery from './modal-gallery'
import citySearch from './city-search'

window.fancyOpt = {
    closeExisting: true,
    autoFocus: false,
    backFocus: false,
    slideShow: false,
    fullScreen: false,
    thumbs: false,
    closeBtn: true,
    touch: false,
    closeClickOutside: true,
    buttons: false,
    animationDuration: 600,
    smallBtn: true,
    hash: false,
    btnTpl: {
        smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg width="20" height="20"><use xlink:href="#close"></use></svg></button>'
    },
    afterLoad: function () {
        //modalsListeners();
        setTimeout(function () {
            citySearch();
        }, 100);
    }
};



window.fancyOpt2 = {
    closeExisting: true,
    autoFocus: false,
    backFocus: false,
    slideShow: true,
    fullScreen: false,
    thumbs: false,
    closeBtn: true,
    touch: true,
    closeClickOutside: true,
    buttons: false,
    animationDuration: 600,
    smallBtn: true,
    hash: false,
    btnTpl: {
        smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg width="20" height="20"><use xlink:href="#close"></use></svg></button>'
    },
    afterLoad: function () {
        modalsListeners();
        setTimeout(function () {
            citySearch();
        }, 100);
    }
};

window.fancyOpt3 = {
    loop: true,
    closeExisting: true,
    autoFocus: false,
    backFocus: false,
    slideShow: true,
    fullScreen: false,
    thumbs: false,
    closeBtn: true,
    touch: true,
    transitionEffect: "slide",
    closeClickOutside: true,
    buttons: [
        "close"
    ],
    animationDuration: 600,
    smallBtn: false,
    hash: false,
    gutter: 0,
    btnTpl: {
        close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
            '<svg width="20" height="20"><use xlink:href="#close"></use></svg>' +
            "</button>",
        arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow fancybox-button--arrow_left" title="{{PREV}}">' +
            '<svg width="32" height="35"><use xlink:href="#arrow-left-big"></use> </svg>' +
            "</button>",
        arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<svg width="32" height="35"><use xlink:href="#arrow-right-big"></use> </svg>' +
            "</button>"
    },
    baseTpl:
        '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-toolbar">{{buttons}}</div>' +
        '<div class="fancybox-inner">' +
        '<div class="fancybox-navigation">{{arrows}}</div>' +
        '<div class="fancybox-stage"></div>' +
        '</div></div>'
};



export default function () {

    modalsListeners();
    $('body').on('click', '.js-close-modal', function () {
        $.fancybox.close();
    });
}
